import React from "react";
import {
    FaFacebookF,
    FaInstagram,
    FaTwitter,
    FaYoutube,
    FaLinkedinIn,
    FaWhatsapp,
} from "react-icons/fa";
import "../css/FloatingSocialMenu.css";

function FloatingSocialMenu() {
    // Social links list configuration
    const socialLinks = [
        {
            name: "WhatsApp",
            icon: <FaWhatsapp className="floater-icon" />,
            url: "https://wa.me/916289581169?text=Hello%20Crestest%20Learning%20Team,%20I%20would%20like%20to%20know%20more%20about%20your%20courses.",
            className: "floater-whatsapp"
        },
        {
            name: "Facebook",
            icon: <FaFacebookF className="floater-icon" />,
            url: "https://www.facebook.com/profile.php?id=100070855191458&mibextid=ZbWKwL",
            className: "floater-facebook"
        },
        {
            name: "Instagram",
            icon: <FaInstagram className="floater-icon" />,
            url: "https://www.instagram.com/crestestlearning?igsh=MTMyaGNyNGhxbzMyOA==",
            className: "floater-instagram"
        },
        {
            name: "X (Twitter)",
            icon: <FaTwitter className="floater-icon" />,
            url: "https://x.com/CrestestL?t=HZ0eOHnnFhuaUxE6Ottp0w&s=08",
            className: "floater-twitter"
        },
        {
            name: "YouTube",
            icon: <FaYoutube className="floater-icon" />,
            url: "https://youtube.com/@crestestlearning7882?si=C3Nc705m7PwsRWaz",
            className: "floater-youtube"
        },
        {
            name: "LinkedIn",
            icon: <FaLinkedinIn className="floater-icon" />,
            url: "https://www.linkedin.com/posts/crestest-learning_activity-7120658377931710464-fR85?utm_source=share&utm_medium=member_android",
            className: "floater-linkedin"
        }
    ];

    return (
        <div className="crest-floater-right-container">
            {/* Header / Handle Tag matching style */}
            {/* <div className="crest-floater-header-tag" title="Connect With Us">
                <FaShareAlt className="floater-header-icon" />
                <span className="floater-header-label">Connect</span>
            </div> */}

            {/* Mapped Social Buttons */}
            {socialLinks.map((social, index) => (
                <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`crest-floater-right-btn ${social.className}`}
                    title={social.name}
                >
                    {/* <span className="floater-label">{social.name}</span> */}
                    {social.icon}
                </a>
            ))}
        </div>
    );
}

export default FloatingSocialMenu;